import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { BotChat } from "../../interfaces/chabot";
import { useRenameChat } from "../Sirius/SiriusQueries";
import { DialogProps } from "./useDialogs";

function RenameChatDialog({ payload, open, onClose }: DialogProps<BotChat>) {
  const [newTitle, setNewTitle] = useState("");
  const { mutate: renameMutate } = useRenameChat(payload.bot.id);

  const handleRename = () => {
    renameMutate({ chatId: payload.id, title: newTitle });
    onClose();
    setNewTitle("");
  };

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>Renommer la conversation</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Nouveau titre"
          fullWidth
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button onClick={handleRename} variant="contained">
          Renommer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RenameChatDialog;
